import { FetchErrorPayload } from '../fetch-middleware.types';

const FALLBACK_ERROR_MESSAGE = 'Unknown server response';

export async function resolveErrorPayload (error: any): Promise<FetchErrorPayload> {
    const errorPayload: FetchErrorPayload = {
        code: 1,
        message: FALLBACK_ERROR_MESSAGE,
        originalError: error
    };

    if (error instanceof Response) {
        const jsonText = await parseResponseJsonText(error);

        errorPayload.status = error.status;

        if (jsonText?.['code']) {
            errorPayload.code = jsonText.code;
        }

        if (jsonText?.['message']) {
            errorPayload.message = jsonText.message;
        }

        return errorPayload;
    }

    return errorPayload;
}

export function defaultResponseTransform (response: Response) {
    return response.json();
}

async function parseResponseJsonText (response: Response) {
    const text = await response.text();

    try {
        const json = JSON.parse(text);

        return json;
    } catch (err) {
        return FALLBACK_ERROR_MESSAGE;
    }
}

export async function nullResponse () {
    // there is no response data to transform, so the default json throws
    return null;
}
